import React, { useState } from "react";
import { HERO } from "../../data";
import { CONFIG, isPlaceholder } from "../../config";
import { goTo } from "../../App";
import { Play } from "lucide-react";
import { toast } from "sonner";

export default function Hero() {
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    if (isPlaceholder(CONFIG.VIDEO_URL)) {
      toast("La lezione sarà disponibile a breve.", {
        description: "Iscriviti alla live del lunedì per non perdertela.",
      });
      goTo("live");
      return;
    }
    setPlaying(true);
  };

  return (
    <section id="video" className="sec" style={{ paddingTop: 56 }}>
      <div className="mx-auto max-w-[840px] px-4 text-center reveal">
        <div className="kicker mb-6">{HERO.kicker}</div>
        <h1 className="display" style={{ fontSize: "clamp(2.3rem, 7vw, 4.4rem)" }}>
          {HERO.h1a} <span className="blue">{HERO.h1accent}</span>
          {HERO.h1b ? (<><br />{HERO.h1b}</>) : null}
        </h1>
        <p className="mx-auto mt-7" style={{ maxWidth: "60ch", fontSize: "1.08rem" }}>
          {HERO.sub}
        </p>
        <p className="mt-4" style={{ fontSize: "0.92rem", color: "rgba(155,150,176,0.75)" }}>
          {HERO.line}
        </p>
      </div>

      {/* Video facade */}
      <div className="mx-auto max-w-[880px] px-4 mt-9">
        <div className="relative w-full panel overflow-hidden" style={{ aspectRatio: "16 / 9", padding: 0 }}>
          {playing && !isPlaceholder(CONFIG.VIDEO_URL) ? (
            <iframe
              title="Lezione gratuita HighTicketSales"
              src={CONFIG.VIDEO_URL}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button onClick={handlePlay} className="group absolute inset-0 w-full h-full" aria-label="Guarda la lezione">
              <img src={CONFIG.VIDEO_THUMBNAIL} alt="Claudio, high ticket sales coach, nella videolezione gratuita sulla vendita consulenziale" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
              <span className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(1,7,26,0.25), rgba(1,7,26,0.55))" }} />
              <span
                className="absolute left-1/2 top-1/2 flex items-center justify-center rounded-full transition-transform group-hover:scale-105"
                style={{ transform: "translate(-50%,-50%)", width: 78, height: 78, background: "var(--blue)", boxShadow: "0 12px 40px rgba(46,107,255,0.6)" }}
              >
                <Play size={30} color="#fff" style={{ marginLeft: 4 }} />
              </span>
              <span className="absolute bottom-3 right-3 px-2 py-1 rounded" style={{ background: "rgba(0,0,0,0.7)", color: "#fff", fontSize: "0.72rem", fontWeight: 600 }}>
                {CONFIG.VIDEO_DURATION}
              </span>
            </button>
          )}
        </div>
      </div>

      <div className="mx-auto max-w-[840px] px-4 mt-8 flex flex-col items-center gap-4">
        <button onClick={handlePlay} className="btn btn-blue w-full sm:w-auto">
          <Play size={18} /> {HERO.ctaPrimary}
        </button>
        <button onClick={() => goTo("candidatura")} className="link-underline">
          {HERO.ctaSecondary}
        </button>
      </div>
    </section>
  );
}
